/* src/app/features/cnaes-permitidos-grandes-empresas/pesquisa/novo/novo-cnae-permitido.component.scss */
.mw-130 {
  min-width: 130px;
}
.min-margin {
  margin-top: 140px;
}
/*# sourceMappingURL=novo-cnae-permitido.component.css.map */
